import React, { useEffect } from 'react'
import Navbar from '../navbar/Navbar';

const AllDocumentsNew = () => {

    useEffect(()=>{
        window.location.replace("https://alldocuments.raj5823p.workers.dev");
    },[]);
  return (
    <div>
      <p>Redirecting...</p>
    </div>
  )
}

export default AllDocumentsNew;
